<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa()"/>
    <div class="content">
      <div class="container-fluid">
        <loading v-show="load"/>
        <div v-show="!load">
          <div class="d-flex align-items-center justify-content-between">
            <h1 class="h3 mb-0 text-gray-800">Disparos</h1>
            <div>
              <button class="btn btn-danger" @click="novaNotificacao()">
                <i class="fas fa-plus"></i> Novo Disparo
              </button>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-3 mb-3" v-if="!boasPraticas">
              <button class="btn btn-outline-info" @click="boasPraticas=true"><i class="fa fa-lightbulb mr-1"></i> Boas práticas</button>
            </div>
            <div class="col-md-3 mb-3 ml-auto">
              <select class="form-control" @change="filtrarDisparo()" v-model="pesquisa.status">
                <option value="" disabled>Selecione um fitro</option>
                <option value="1">Aguardando</option>
                <option value="2">Finalizados</option>
                <option value="3">Cancelados</option>
                <option value="4">Expirados</option>
              </select>
            </div>
          </div>
          <div class="card shadow-sm" v-if="!boasPraticas">
            <div class="card-body">
              <div class="table-responsive" style="min-height: 100px">
                <table class="table mb-0" v-if="disparos.length">
                  <thead class="border-bottom">
                  <tr>
                    <th style="width: 300px">Titulo</th>
                    <th style="width: 150px">Status</th>
                    <th class="text-nowrap" style="width: 100px">Data disparo</th>
                    <th>&nbsp;</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="pointer" v-for="n in disparos">
                    <td class="align-middle" @click="selNotificacao(n.id_disparo)">
                      {{n.nome_disparo}}
                    </td>
                    <td class="align-middle text-nowrap" @click="selNotificacao(n.id_disparo)">
                      {{ n.status | statusN }}
                    </td>
                    <td class="align-middle text-nowrap small" @click="selNotificacao(n.id_disparo)">
                      <div v-if="n.status === '1' && progress > 0">Disparado: {{progress}}%</div>
                      <div v-else>{{ n.disparo }}</div>
                    </td>
                    <td class="align-middle text-nowrap text-right">
                      <button class="btn btn-outline-dark btn-sm mr-3" @click="toggleNotificacao(n, '3')" title="Clique para cancelar este disparo" :disabled="load" v-if="n.status === '1'">
                        <i class="fa fa-stop-circle mr-1"></i> Cancelar disparo
                      </button>
                      <button class="btn btn-dark btn-sm mr-1" title="Deletar Disparo" @click="deletarNotificacao(n.id_disparo)"><i class="fas fa-trash-alt"></i></button>
                      <button class="btn btn-warning text-white btn-sm mr-1" title="Duplicar Disparo" @click="duplicarDisparo(n)"><i class="fa fa-clone"></i></button>
                      <button class="btn btn-info btn-sm" title="Editar Disparo" @click="selNotificacao(n.id_disparo)"><i class="fas fa-pencil-alt"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="text-center" style="margin-top: 42px" v-else>
                  <h6>Nenhum disparo com o status <b>"{{ pesquisa.status | statusN }}" </b> foi encontrado</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm" v-else>
            <div class="card-body py-4">
              <h6 class="font-weight-bold mb-1">📵 Evite banimentos no WhatsApp:</h6>
              <p class="mb-0">Utilize com consciência e estratégia! Respeite seus clientes e preserve sua conta.</p>
              <hr>
              <b>💡 Boas Práticas</b>
              <p>O WhatsApp está cada vez mais rígido com contas que realizam disparos excessivos ou com conteúdo repetitivo. Quando a plataforma identifica esse comportamento, pode entender como spam e aplicar punições, como restrições ou banimento da conta.</p>

              <b>⚠️ Atenção</b>
              <p>Nosso sistema segue boas práticas de envio e oferece recursos para reduzir os riscos. No entanto, o uso inadequado pode gerar bloqueios. <b>Não nos responsabilizamos por eventuais banimentos</b> decorrentes do mau uso da ferramenta.</p>

              <b>📴 Evite ser bloqueado pelos clientes</b>
              <p>O envio frequente ou de mensagens irrelevantes pode causar incômodo e levar os próprios clientes a bloquearem o número, aumentando ainda mais o risco de punição pelo WhatsApp.</p>

              <b>📆 Não envie todo dia</b>
              <p>Use o disparo com consciência. <b>Evite o envio diário.</b> Priorize ações pontuais e estratégicas, como promoções, comunicados importantes ou novidades.</p>

              <b>💬 Evite mensagens idênticas</b>
              <p>Utilize a variável "nome do cliente" acessando: Variáveis > Nome do Cliente. Personalizar suas mensagens é essencial — além de tornar a comunicação mais humanizada, aumenta significativamente as chances de engajamento com o seu público.</p>

              <b>⌛ Duração do disparo de mensagens</b>
              <p>Adotamos um intervalo aleatório entre 5 e 10 segundos por mensagem, o que pode levar até 120 minutos para enviar 1000 mensagens. Essa prática ajuda a reduzir os riscos e garantir mais segurança no disparo.</p>

              <hr>
              <div class="text-center mt-3">
                <button class="btn btn-outline-info btn-sm px-4" @click="filtrarDisparo()">Ok, entendi!</button>
              </div>
            </div>
          </div>
        </div>

        <modal width="full" :opened="modalDisparo" @fechar="modalDisparo=false">
          <modal-notificacao :token="token" @atualizarDados="atualizarNotificacoes"/>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../components/commons/Modal";
import Loading from "../components/commons/Loading";
import ModalNotificacao from "../components/disparos/ModalNotificacao";
import TopBar from "../components/commons/TopBar";

export default {
  name: 'NotificacoesLebot',
  components: {TopBar, ModalNotificacao, Loading, Modal},
  data() {
    return {
      token: localStorage.getItem('key'),
      empresa: localStorage.getItem('token'),
      load: false,
      disparos: [],
      modalDisparo: false,
      dados: null,
      boasPraticas: true,
      pesquisa: { status: '' }
    }
  },

  methods: {
    buscarDisparos(notLoad, callback) {
      this.load = !notLoad;
      this.$http.get("chatbot/disparos/" + this.token, { params: this.pesquisa }).then(response => {
        this.load = false;
        this.disparos = response.data || [];

        this.$nextTick(() => {
          if (callback) {
            callback();
          }
        })

      }, res => {
        this.load = false;
        console.log(res);
        this.$swal(res.data.result,res.data.msg);
      });
    },

    selNotificacao(id_disparo) {
      this.modalDisparo = true;
      this.$emit('openModal', { id_disparo });
    },

    deletarNotificacao(id_disparo) {
      this.$swal({
        text: `Atenção, deseja deletar esta notificação?`,
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true,
      }).then(r => {
        if (r) {
          this.load = true;
          this.$http.post('chatbot/disparos/' + this.token, { id_disparo, deletar: '1' })
            .then(response => {
              this.load = false;
              this.buscarDisparos();
              this.$swal('Notificacão removida com sucesso!');

            }, res => {
              this.load = false;
              this.$swal(res.data.msg);
            });
        }
      });
    },

    duplicarDisparo(dados) {
      this.$swal({
        text: `Deseja duplicar este disparo: "${dados.nome_disparo}"?`,
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          this.modalDisparo = true;
          this.$emit('openModal', { id_disparo: dados.id_disparo, duplicar: true });
        }
      });
    },

    filtrarDisparo() {
      this.boasPraticas = false;
      this.pesquisa.status = this.pesquisa.status || '1';
      this.buscarDisparos();
    },

    novaNotificacao() {
      if (this.boasPraticas) {
        this.filtrarDisparo();
      }

      this.modalDisparo = true;
      this.$emit('openModal', null);
    },

    toggleNotificacao(n, status) {
      this.$swal({
        text: `Atenção, deseja cancelar este disparo?`,
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true,
      }).then(r => {
        if (r) {
          if (n.status === '1') {
            this.$emit('cancelarDisparo');
            this.$store.state.progressDisparo = 0;
          }

          this.load = true;
          this.$http.post('chatbot/disparos/status/' + this.token, { id_disparo: n.id_disparo, status }).then(res => {
            this.load = false;
            this.buscarDisparos();

          }, res => {
            this.load = false;
            this.$swal(res.data.msg ? res.data.msg : 'Erro temporário');
          });
        }
      });
    },

    atualizarNotificacoes(disparar) {
      this.pesquisa.status = '1';
      this.modalDisparo = false;
      this.buscarDisparos(false, () => {
        if (!disparar) return;

        setTimeout(() => {
          if (this.isElectron) {
            this.$emit('buscarDisparos', null);

          } else {
            this.$socket.emit('trigger_bot', { token: localStorage.getItem('token') });
          }
        }, 1500)
      });
    },

    changeEmpresa() {
      this.token = localStorage.getItem('key');
      this.filtrarDisparo();
    }
  },

  computed: {
    progress() {
      return this.$store.state.progressDisparo;
    },

    wpp_session() {
      return this.$store.state.wpp_session;
    }
  },

  watch: {
    progress(val) {
      if (!val || val === 1) {
        console.log('buscar disparos watch');
        this.buscarDisparos(true);
      }
    }
  },

  filters: {
    statusN(s) {
      switch (s) {
        case '0':
            return 'Aguardando';
        case '1':
          return 'Disparando';
        case '2':
          return 'Finalizado';
        case '3':
          return 'Cancelado';
        case '4':
          return 'Expirados';
        default:
          return '';
      }
    }
  }
}
</script>
